import type { CSSProperties } from 'react';
interface Props {
  score: number;
  size?: 'small' | 'large';
}

export function SignalRing({ score, size = 'small' }: Props) {
  return (
    <div className={`signal-ring ${size}`} style={{ '--score': `${score * 3.6}deg` } as CSSProperties} aria-label={`${score} out of 100`}>
      <span>{score}</span>
      <small>/100</small>
    </div>
  );
}
